export enum CurrencyUnit {
  USD = 'usd',
  EUR = 'eur',
  GBP = 'gbp',
}

export interface CreateQuoteBody {
  coverageStartDate: string;
  coverageEndDate: string;
  coverageStartHourNumber?: number;
  coverageEndHourNumber?: number;
  currency: string;
  exposureName: string;
  exposureLatitude: number;
  exposureLongitude: number;
  exposureTotalCoverageAmount: number;
  langLocale?: string;
}

export interface Quote {
  id: string;
  pricePerDay: number;
  totalPrice: number;
  dailyCoverageStartHour: number;
  dailyCoverageEndHour: number;
  sortedTiers: CoverageTier[];
  currency: CurrencyUnit;
  exposureProtections: ExposureProtection[];
}

export interface CoverageTier {
  hours: number;
  reimbursementRate: number;
}

export interface ExposureProtection {
  name: ProtectionType;
  unit: string;
  upperThreshold?: number;
  lowerThreshold?: number;
}

export enum ProtectionType {
  RAINFALL = 'rainfall',
  TEMPERATURE = 'temperature',
  WIND = 'windspeed',
  AIR_QUALITY = 'air quality',
  SNOW = 'snow',
}

export enum EnvironmentName {
  PRODUCTION = 'production',
  SANDBOX = 'sandbox',
}
